export const CONFIRMATION_DIALOG__DELETE_GOOGLE_TOOL = 'CONFIRMATION_DIALOG__DELETE_GOOGLE_TOOL';
